import styled from 'styled-components'
import { Calendar } from 'react-multi-date-picker'
import { COLORS } from 'theme'

export const StyledCalender = styled(Calendar)`
  margin-right: 2rem;
  box-shadow: 0 0 1px transparent !important;
  position: relative;
  top: -1rem;
  left: -1rem;
  .rmdp-day.rmdp-today span {
    border: 2px solid ${COLORS.PRIMARY};
    border-radius: 50%;
  }

  .rmdp-day.rmdp-selected span:not(.highlight),
  .rmdp-day.rmdp-selected.rmdp-today span {
    background-color: ${COLORS.PRIMARY} !important;
    color: white;
  }

  .rmdp-day:not(.rmdp-selected) span {
    background-color: transparent !important;
    color: inherit;
  }

  .rmdp-day:not(.rmdp-selected):hover span {
    color: ${COLORS.PRIMARY};
    font-weight: bold;
  }
  .rmdp-week-day {
    color: ${COLORS.PRIMARY} !important ;
  }
  .rmdp-shadow {
    border-collapse: inherit !important;
  }
`
